module.exports = __webpack_public_path__ + "assets/img/jp_16.e24cd3fc.jpg";